import React from 'react';
import './service.css';
import servicedata from './servicedata';
import ServiceList from './ServiceList';

function Service() {
    return (
        <div className='service'>
            <div className="container">
               <h1 className="subtitle">Service</h1>
               <h1 className="title">What we do ?</h1>
               {/* <p className="para">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolorem ea temporibus atque porro impedit!</p> */}

               <div className="service-grid">
                   {servicedata.map(service =>{
                       return <ServiceList key={service.id} content={service}/>
                   })}
               </div>
            </div>

            <div className="circle-round"></div>
            <img src={process.env.PUBLIC_URL + '/image/icons/dot.png'} className="dotted" alt="Ashish Gupta"/>
            <img src={process.env.PUBLIC_URL + '/image/icons/light-star.png'} className="light-star" alt="Ashish Gupta"/>
            <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave" alt="Ashish Gupta"/>
            <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave wave2" alt="Ashish Gupta"/>


        </div>
    )
}

export default Service
